import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateBlogSection } from "../../api/apiBlogSection";
import parseError from "../../utils/parseError";

export function useUpdateBlogSection() {
    const queryClient = useQueryClient();

    const { mutate: updateBlogSectionMutate, isPending } = useMutation({
        mutationFn: updateBlogSection,
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-section"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update blog section");
        },
    });

    return { updateBlogSectionMutate, isPending };
}
